/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Logging_Rounding_DumbbellInputs */

const en_us2_workout_logging_rounding_dumbbell = /** @type {(inputs: Workout_Logging_Rounding_DumbbellInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dumbbells`)
};

const pt_br2_workout_logging_rounding_dumbbell = /** @type {(inputs: Workout_Logging_Rounding_DumbbellInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Halteres`)
};

const es_419_workout_logging_rounding_dumbbell = /** @type {(inputs: Workout_Logging_Rounding_DumbbellInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mancuernas`)
};

const pt_pt2_workout_logging_rounding_dumbbell = /** @type {(inputs: Workout_Logging_Rounding_DumbbellInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Halteres`)
};

const fr_fr2_workout_logging_rounding_dumbbell = /** @type {(inputs: Workout_Logging_Rounding_DumbbellInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haltères`)
};

const de_de2_workout_logging_rounding_dumbbell = /** @type {(inputs: Workout_Logging_Rounding_DumbbellInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kurzhanteln`)
};

const it_it2_workout_logging_rounding_dumbbell = /** @type {(inputs: Workout_Logging_Rounding_DumbbellInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manubri`)
};

/**
* | output |
* | --- |
* | "Dumbbells" |
*
* @param {Workout_Logging_Rounding_DumbbellInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_logging_rounding_dumbbell = /** @type {((inputs?: Workout_Logging_Rounding_DumbbellInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Logging_Rounding_DumbbellInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_logging_rounding_dumbbell(inputs)
	if (locale === "es-419") return es_419_workout_logging_rounding_dumbbell(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_logging_rounding_dumbbell(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_logging_rounding_dumbbell(inputs)
	if (locale === "de-DE") return de_de2_workout_logging_rounding_dumbbell(inputs)
	if (locale === "it-IT") return it_it2_workout_logging_rounding_dumbbell(inputs)
	return en_us2_workout_logging_rounding_dumbbell(inputs)
});
export { workout_logging_rounding_dumbbell as "workout-logging.rounding_dumbbell" }